import React from 'react'
import { useSelector } from 'react-redux'

import { MultiSelect } from 'components/Forms'
import { UserHiringData, UserSpecificRestrictions } from 'Manager/Users/components'
import { getUserOptions } from 'services/Users'

const UserInput = ({ required, disabled }) => {
  const { users } = useSelector(state => state.resources)

  // Function to custom format the user label in the edit modal
  const userLabel = ({ label, hiringData = [], specificRestrictions }, meta) => {
    // If we are rendering only the value with the menu closed
    if (meta.context === 'value') return label

    // Otherwise render with hiring data
    return (
      <span>
        <b>{label}</b>
        <span className="font-italic ml-1">
          (<UserHiringData hiringData={hiringData} />)
        </span>
        <div>
          <UserSpecificRestrictions specificRestrictions={specificRestrictions} canBeNull />
        </div>
      </span>
    )
  }

  return (
    <MultiSelect
      module="manager.schedule.eventForm"
      name="employeeId"
      options={getUserOptions(users)}
      isClearable
      formatOptionLabel={userLabel}
      required={required}
      disabled={disabled}
    />
  )
}

export default UserInput
